import { TourPractice } from "./TourPractice";

const steps = [
  { target:"caixa-pagar", title:"Revise antes de pagar", text:"Depois de adicionar produtos ao carrinho e conferir o desconto, Pagar abre os meios de pagamento disponíveis. Este guia não abre nem confirma uma venda." },
  { target:"caixa-carrinho", title:"Dinheiro, troco e confirmação", text:"Na opção Dinheiro, informe o valor recebido para calcular o troco. Revise os itens antes de confirmar: a confirmação registra uma venda real. Nesta demonstração você só conhece o fluxo, sem alterar o caixa." },
];
export function TourPdvInteractive({ onDone }) {
  return <TourPractice steps={steps} onDone={onDone} interactive={false} />;
}
